module.exports = __webpack_public_path__ + "img/coventry-city-logo-icon.2b80362b.webp";